<template>
  <div>
    <DialogBase
      :visible="dialogVisible"
      title="Cập nhật tin tức lớp học"
      size="xl"
      top="20px"
      :close-on-click-modal="false"
      panel-icon="el-icon-edit-outline"
      panel-title="Cập nhật tin tức"
      panel-subtitle="Điều chỉnh nội dung, tệp đính kèm và lịch gửi"
      @update:visible="handleVisibleUpdate"
    >
      <el-form ref="updateData" :model="fromData" :rules="rules" label-position="top" size="small" class="notify-two-col-form">
        <el-row :gutter="20">
          <!-- Cột trái (62%): Tiêu đề, Nội dung & Đường dẫn -->
          <el-col :span="15">
            <div class="left-form-pane">
              <el-form-item prop="title" label="Tiêu đề thông báo">
                <el-input placeholder="Nhập tiêu đề thông báo..." v-model="fromData.title" clearable></el-input>
              </el-form-item>

              <el-form-item label="Nội dung thông báo" prop="content">
                <div class="content-toolbar">
                  <div class="mode-switch-group">
                    <el-radio-group v-model="contentViewMode" size="mini">
                      <el-radio-button label="editor">
                        <i class="el-icon-edit" /> Soạn thảo
                      </el-radio-button>
                      <el-radio-button label="preview">
                        <i class="el-icon-view" /> Xem thực tế
                      </el-radio-button>
                      <el-radio-button label="source">
                        <i class="el-icon-tickets" /> Mã nguồn HTML
                      </el-radio-button>
                    </el-radio-group>
                  </div>
                  <div class="dialog-switch-group">
                    <el-button
                      v-if="contentViewMode === 'preview'"
                      size="mini"
                      type="primary"
                      plain
                      icon="el-icon-full-screen"
                      @click="handleOpenPreviewDialog"
                    >
                      Mở cửa sổ lớn
                    </el-button>
                    <el-button
                      v-if="contentViewMode === 'source'"
                      size="mini"
                      type="warning"
                      plain
                      icon="el-icon-document-copy"
                      @click="handleCopyHtmlSource"
                    >
                      Sao chép mã
                    </el-button>
                    <el-button
                      v-if="contentViewMode === 'source'"
                      size="mini"
                      type="info"
                      plain
                      icon="el-icon-full-screen"
                      @click="handleOpenSourceDialog"
                    >
                      Cửa sổ mã nguồn
                    </el-button>
                  </div>
                </div>

                <!-- Mode 1: Editor -->
                <div v-show="contentViewMode === 'editor'">
                  <TextEditor v-model="fromData.content" height="380px" ref="textEditor" :editorService="TextEditorTeacherService"></TextEditor>
                </div>

                <!-- Mode 2: Xem thực tế (Rendered HTML) -->
                <div v-show="contentViewMode === 'preview'" class="html-preview-container">
                  <div class="preview-device-card">
                    <div class="preview-card-header">
                      <span class="preview-title">{{ fromData.title || 'Tiêu đề thông báo' }}</span>
                      <el-tag size="mini" type="success">Xem thực tế</el-tag>
                    </div>
                    <div class="preview-card-body">
                      <div v-if="fromData.content" class="html-content-render" v-html="fromData.content"></div>
                      <div v-else class="preview-empty-text">
                        <i class="el-icon-document-remove" /> Chưa có nội dung để hiển thị
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Mode 3: Hiển thị mã nguồn HTML -->
                <div v-show="contentViewMode === 'source'" class="html-source-container">
                  <div class="source-code-header">
                    <span class="source-info"><i class="el-icon-tickets" /> Mã nguồn HTML (có thể xem và chỉnh sửa):</span>
                  </div>
                  <el-input
                    type="textarea"
                    :rows="15"
                    v-model="fromData.content"
                    placeholder="Mã nguồn HTML..."
                    class="source-code-textarea"
                  ></el-input>
                </div>
              </el-form-item>

              <el-form-item prop="link" label="Đường dẫn liên kết đính kèm">
                <el-input placeholder="https://example.com..." v-model="fromData.link" prefix-icon="el-icon-link" clearable></el-input>
              </el-form-item>
            </div>
          </el-col>

          <!-- Cột phải (38%): Phạm vi, Thời gian & Tệp đính kèm -->
          <el-col :span="9">
            <div class="right-form-pane">
              <!-- Card 1: Phạm vi nhận -->
              <div class="notify-card-box">
                <div class="card-box-header">
                  <i class="el-icon-s-custom" />
                  <span class="card-title">Phạm vi nhận tin</span>
                </div>
                <div class="card-box-body">
                  <div class="nfs-scope-selector">
                    <el-select v-model="scopeForm" class="w-full" placeholder="Chọn phạm vi" disabled style="width: 100%;" @change="handleChangeScopeApply">
                      <el-option v-for="(item, index) in listScopeApply" :key="index" :label="item.label" :value="item.value" />
                    </el-select>
                  </div>

                  <div class="nfs-scope-buttons" style="margin-top: 10px;">
                    <el-button 
                      class="nfs-choice-btn" 
                      type="primary"
                      size="small" 
                      :plain="true" 
                      icon="el-icon-folder"
                      @click="handleShowApplyKid"
                      style="width: 100%;"
                    >
                      Chọn Lớp ({{ applyForm.kids.length }})
                    </el-button>
                  </div>

                  <div class="nfs-scope-lists" style="margin-top: 10px;">
                    <div :class="['nfs-scope-list-box']">
                      <div class="nfs-list-box-title">
                        <div class="title-left">
                          <i class="el-icon-folder-opened" style="color: #eab308; font-size: 15px;" />
                          <span>Danh sách học sinh ({{ applyForm.kids.length }})</span>
                        </div>
                        <span class="nfs-title-tag">
                          Lớp học ({{ applyForm.kids.length }})
                        </span>
                      </div>
                      <div class="nfs-list-box-content">
                        <template v-if="applyForm.kids.length > 0">
                          <div
                            v-for="(kid, index) in applyForm.kids"
                            :key="index"
                            class="nfs-apply-pill"
                          >
                            <i class="el-icon-circle-check text-green-500" />
                            <span>{{ kid.kidsName || kid.kidName || kid.fullName }}<span v-if="kid.className"> ({{ kid.className }})</span></span>
                          </div>
                        </template>
                        <div v-else class="nfs-no-selection">
                          {{ isShowButtonScope.class ? 'Chưa chọn học sinh nào' : 'Chưa chọn' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Card 2: Thời gian gửi -->
              <div class="notify-card-box">
                <div class="card-box-header">
                  <i class="el-icon-time" />
                  <span class="card-title">Thời gian gửi</span>
                </div>
                <div class="card-box-body">
                  <template v-if="isSent">
                    <el-tag type="info" size="medium">
                      <i class="el-icon-info" /> {{ formatNotifySendStatus(fromData.sendType) }} {{ fromData.scheduledTime | formatDateTime }}
                    </el-tag>
                  </template>
                  <template v-else>
                    <el-radio-group v-model="fromData.sendType" size="small" @change="handleSendTypeChange" class="send-type-segmented">
                      <el-radio-button label="IMMEDIATE"><i class="el-icon-s-promotion" /> Gửi ngay</el-radio-button>
                      <el-radio-button label="SCHEDULED"><i class="el-icon-date" /> Lên lịch gửi</el-radio-button>
                    </el-radio-group>
                    <div v-if="fromData.sendType === 'SCHEDULED'" style="margin-top: 10px;">
                      <el-date-picker
                        v-model="fromData.scheduledTime"
                        type="datetime"
                        placeholder="Chọn ngày giờ gửi"
                        :picker-options="pickerOptions"
                        style="width: 100%;"
                        size="small"
                        @focus="resetScheduledTime"
                      ></el-date-picker>
                    </div>
                  </template>
                </div>
              </div>

              <!-- Card 3: Tệp & Hình ảnh đính kèm (Drag and Drop) -->
              <div class="notify-card-box">
                <div class="card-box-header">
                  <i class="el-icon-paperclip" />
                  <span class="card-title">Đính kèm ảnh & tệp</span>
                  <span class="badge-file-count">Tổng: {{ totalFiles }}/3 tệp</span>
                </div>
                <div class="card-box-body">
                  <!-- Upload Hình Ảnh Drag & Drop -->
                  <div class="upload-drop-section">
                    <span class="upload-sublabel"><i class="el-icon-picture-outline" /> Hình ảnh đính kèm:</span>
                    <el-upload
                      drag
                      @click.native="resetWaningImg"
                      action="/api/upload/"
                      list-type="picture"
                      :auto-upload="false"
                      :on-preview="handlePictureCardPreview"
                      :file-list="imageFileList"
                      :on-change="handleChangeImg"
                      :on-remove="handleRemoveImg"
                      accept=".jpg,.jpeg,.png,.webp"
                      multiple
                      ref="uploadImg"
                      :limit="3"
                      :on-exceed="handleExceed"
                      :disabled="totalFiles >= 3"
                      class="drag-dropzone-uploader"
                      :class="{ 'hide-trigger': totalFiles >= 3 }"
                    >
                      <i class="el-icon-upload" />
                      <div class="el-upload__text">Kéo thả ảnh vào đây hoặc <em>chọn tệp</em></div>
                    </el-upload>
                  </div>

                  <!-- Upload Document Files Drag & Drop -->
                  <div class="upload-drop-section" style="margin-top: 12px;">
                    <span class="upload-sublabel"><i class="el-icon-document" /> File tài liệu bổ sung:</span>
                    <el-upload
                      drag
                      action="/api/upload/"
                      :auto-upload="false"
                      :file-list="excelFileList"
                      :on-change="handleChangeFile"
                      :on-remove="handleRemoveExcel"
                      :on-preview="downloadItem"
                      accept=".xls,.xlsx,.doc,.docx,.pdf,.txt,.zip,.rar"
                      multiple
                      ref="uploadExcel"
                      :limit="3"
                      :on-exceed="handleExceed"
                      :disabled="totalFiles >= 3"
                      class="drag-dropzone-file-uploader"
                    >
                      <i class="el-icon-upload" />
                      <div class="el-upload__text">Kéo thả file vào đây hoặc <em>chọn tệp</em></div>
                    </el-upload>
                  </div>

                  <el-progress
                    style="margin-top: 10px;"
                    :percentage="percentage"
                    v-if="showProgress"
                    :color="colors"
                  ></el-progress>
                </div>
              </div>

            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer sk-dialog-footer">
        <el-button type="danger" size="medium" @click.prevent="resetField('updateData')">
          <i class="el-icon-circle-close" />
          <span>Đóng</span>
        </el-button>
        <el-button type="success" size="medium" :loading="loadingButton" mini @click.prevent="submitForm('updateData')">
          <i class="el-icon-circle-check" />
          <span>Lưu</span>
        </el-button>
      </span>
    </DialogBase>

    <!-- Dialog Xem trước ảnh -->
    <DialogBase
      :visible="dialogVisible1"
      width="30%"
      :show-footer="false"
      panel-icon="el-icon-picture-outline"
      panel-title="Xem trước ảnh"
      @update:visible="handlePreviewVisibleUpdate"
    >
      <img width="100%" :src="dialogImageUrl" alt />
    </DialogBase>

    <!-- Dialog Xem thực tế HTML dạng popup lớn -->
    <DialogBase
      :visible="dialogPreviewHtmlVisible"
      title="Xem hiển thị nội dung thực tế"
      size="large"
      top="30px"
      :append-to-body="true"
      panel-icon="el-icon-view"
      panel-title="Nội dung thông báo (Thực tế trên Mobile/Web)"
      panel-subtitle="Kiểm tra bảng biểu, định dạng và hình ảnh trước khi lưu"
      @update:visible="val => dialogPreviewHtmlVisible = val"
    >
      <div class="preview-device-card preview-large-box">
        <div class="preview-card-header">
          <span class="preview-title">{{ fromData.title || 'Tiêu đề thông báo' }}</span>
          <el-tag size="mini" type="success">Xem thực tế trên ứng dụng</el-tag>
        </div>
        <div class="preview-card-body">
          <div v-if="fromData.content" class="html-content-render" v-html="fromData.content"></div>
          <div v-else class="preview-empty-text">
            <i class="el-icon-document-remove" /> Chưa có nội dung để hiển thị
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogPreviewHtmlVisible = false">Đóng cửa sổ</el-button>
      </span>
    </DialogBase>

    <!-- Dialog Mã nguồn HTML dạng popup lớn -->
    <DialogBase
      :visible="dialogSourceHtmlVisible"
      title="Mã nguồn HTML"
      size="large"
      top="30px"
      :append-to-body="true"
      panel-icon="el-icon-tickets"
      panel-title="Chi tiết mã nguồn HTML"
      panel-subtitle="Xem, chỉnh sửa hoặc sao chép mã nguồn HTML"
      @update:visible="val => dialogSourceHtmlVisible = val"
    >
      <div class="source-dialog-body">
        <el-input
          type="textarea"
          :rows="18"
          v-model="fromData.content"
          placeholder="Mã nguồn HTML..."
          class="source-code-textarea"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" icon="el-icon-document-copy" size="small" @click="handleCopyHtmlSource">Sao chép mã</el-button>
        <el-button type="primary" size="small" @click="dialogSourceHtmlVisible = false">Hoàn tất</el-button>
      </span>
    </DialogBase>

    <ApplyKidSurveyForm
        scope="CLASS"
        :is-open="isDialogApply.kid"
        @closeDialog="handleCloseDialogApplyKid"
        @confirmData="handleConfirmKidsApply" ref="applyKidSurveyForm" />
  </div>
</template>

<script>
import NotifyTeacherService from "@/services/TeacherService/NotifyTeacherService";
import TextEditorTeacherService from "@/services/TeacherService/TextEditorTeacherService";
import http from "@/http-download";
import TextEditor, { ensureInlineTableStyles } from "@/views/common/TextEditor.vue";
import ApplyKidSurveyForm from "@/views/survey_form/dialog/ApplyKidSurveyForm.vue";
import parseInfoKidVietnameseMixin from "@/global/mixinKid/parseInfoKidVietnamese.mixin";
import { notifySendType } from "../../constant/listCommon";
import moment from 'moment';
import DialogBase from "@/components/DialogBase.vue";

export default {
  components: { TextEditor, ApplyKidSurveyForm, DialogBase },
  props: {
    dialogVisible: null,
  },
  mixins: [parseInfoKidVietnameseMixin],
  computed: {
    totalFiles() {
      return this.imageFileList.length + this.excelFileList.length;
    },
    pickerOptions() {
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      const currentSecond = now.getSeconds();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const selectedDate = new Date(this.fromData.scheduledTime || now);
      let selectableRange = [];

      if (selectedDate.getTime() <= today.getTime() + 8.64e7) {
        selectableRange = [`${currentHour}:${currentMinute}:${currentSecond} - 23:59:59`];
      } else {
        selectableRange = ['00:00:00 - 23:59:59'];
      }

      return {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
        selectableRange,
      };
    }
  },
  data() {
    return {
      showAllKids: false,
      TextEditorTeacherService,
      contentViewMode: "editor",
      dialogPreviewHtmlVisible: false,
      dialogSourceHtmlVisible: false,
      dialogImageUrl: "",
      dialogVisible1: false,
      messageWarningFile: false,
      messageWarningImg: false,
      isSent: false,
      colors: [
        { color: "#f56c6c", percentage: 20 },
        { color: "#e6a23c", percentage: 40 },
        { color: "#5cb87a", percentage: 60 },
        { color: "#1989fa", percentage: 80 },
        { color: "#6f7ad3", percentage: 100 },
      ],
      imageFileList: [],
      excelFileList: [],
      percentage: 0,
      loadingButton: false,
      showProgress: false,
      multipartFileList: [],
      fileDeleteList: [],
      scopeForm: "class",
      listScopeApply: [
        { value: "class", label: "Lớp" },
      ],
      isShowButtonScope: {
        class: true,
      },
      isDialogApply: {
        kid: false,
      },
      applyForm: {
        classes: [],
        kids: [],
      },
      fromData: {
        id: "",
        title: "",
        content: "",
        link: "",
        scope: "class",
        idKidsList: [],
        notifyTeacherAttachFileList: [],
      },
      rules: {
        title: [
          {
            required: true,
            message: "Tiêu đề không được để trống",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "Nội dung không được để trống",
            trigger: "blur",
          },
        ],
      },
      sendType: [
        {
          required: true,
          message: "Vui lòng chọn thời gian gửi",
          trigger: "change",
        },
      ],
      scheduledTime: [
        {
          required: true,
          message: "Vui lòng chọn ngày giờ gửi",
          trigger: "change",
          validator: (rule, value, callback) => {
            if (this.fromData.sendType === "SCHEDULED" && !value) {
              callback(new Error("Vui lòng chọn ngày giờ gửi"));
            } else if (this.fromData.sendType === "SCHEDULED" && value < new Date()) {
              callback(new Error("Thời gian gửi phải là trong tương lai"));
            } else {
              callback();
            }
          },
        },
      ]
    };
  },
  methods: {
    handleVisibleUpdate(value) {
      if (!value) {
        this.closeDialog();
      }
    },
    handlePreviewVisibleUpdate(value) {
      this.dialogVisible1 = value;
    },
    formatNotifySendStatus(sendType) {
      if (sendType === notifySendType.SUCCESS) {
        return "Đã gửi";
      }
      if (sendType === notifySendType.FAIL) {
        return "Gửi thất bại";
      }
      return "Đang chờ"
    },
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.$refs["updateData"].resetFields();
        this.multipartFileList = [];
        this.fileDeleteList = [];
        this.imageFileList = [];
        this.excelFileList = [];
        this.scopeForm = "class";
        this.applyForm = { classes: [], kids: [] };
        this.isShowButtonScope = { class: true };
      }, 300);
      this.isSent = false;
      this.contentViewMode = "editor";
      this.dialogPreviewHtmlVisible = false;
      this.dialogSourceHtmlVisible = false;
      this.$refs.textEditor.handleRemoveMultiImage();
    },

    resetField(form) {
      this.$refs.textEditor.handleRemoveMultiImage();
      this.closeDialogByButton(form)
    },

    closeDialogByButton(from) {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.$refs[from].resetFields();
        this.multipartFileList = [];
        this.fileDeleteList = [];
        this.imageFileList = [];
        this.excelFileList = [];
        this.messageWarningFile = false;
        this.messageWarningImg = false;
        this.scopeForm = "class";
        this.applyForm = { classes: [], kids: [] };
        this.isShowButtonScope = { class: true };
      }, 300);
      this.isSent = false;
      this.contentViewMode = "editor";
      this.dialogPreviewHtmlVisible = false;
      this.dialogSourceHtmlVisible = false;
      this.$refs.textEditor.reset();
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible1 = true;
    },

    handleOpenPreviewDialog() {
      this.fromData.content = ensureInlineTableStyles(this.fromData.content);
      this.dialogPreviewHtmlVisible = true;
    },
    handleOpenSourceDialog() {
      this.fromData.content = ensureInlineTableStyles(this.fromData.content);
      this.dialogSourceHtmlVisible = true;
    },
    handleCopyHtmlSource() {
      if (!this.fromData.content) {
        this.$message.warning("Nội dung HTML đang trống");
        return;
      }
      this.fromData.content = ensureInlineTableStyles(this.fromData.content);
      const textToCopy = this.fromData.content;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy).then(() => {
          this.$message.success("Đã sao chép mã nguồn HTML vào clipboard!");
        }).catch(() => {
          this.fallbackCopyText(textToCopy);
        });
      } else {
        this.fallbackCopyText(textToCopy);
      }
    },
    fallbackCopyText(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        this.$message.success("Đã sao chép mã nguồn HTML!");
      } catch (err) {
        this.$message.error("Không thể sao chép tự động");
      }
      document.body.removeChild(textArea);
    },

    handleChange(file, fileList) {
      this.multipartFileList = fileList.filter((x) => x.id == undefined);
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isPNG) {
        this.$message.error("Ảnh phải có dạng JPG hoặc PNG!");
        this.handleRemove(file);
      }
      if (!isLt5M) {
        this.$message.error("Ảnh không thể vượt quá 5MB");
        this.handleRemove(file);
      }

      return isJPG && isLt5M;
    },
    handleRemove(file, fileList) {
      if (file.id == undefined) {
        this.multipartFileList = fileList.filter((x) => x.id == undefined);
      } else {
        this.fileDeleteList.push(file);
      }
    },
    handleExceed() {
      this.$message.warning(`Chỉ được phép chọn tối đa 3 file`);
    },
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          this.fromData.content = ensureInlineTableStyles(this.fromData.content);
          let formDatas = new FormData();
          formDatas.append("id", this.fromData.id);
          formDatas.append("title", this.fromData.title);
          formDatas.append("content", this.fromData.content);
          formDatas.append("link", this.fromData.link);
          formDatas.append("sendType", this.fromData.sendType);
          this.applyForm.kids.forEach((kid) => {
            formDatas.append("idKidsList", kid.idKid);
          });
          this.multipartFileList = [...this.imageFileList, ...this.excelFileList];
          if (this.multipartFileList && this.multipartFileList.length > 0) {
            this.multipartFileList.forEach((element) => {
              if (element.raw) {
                formDatas.append("multipartFileList", element.raw);
              }
            });
          }

          if (this.fileDeleteList && this.fileDeleteList.length > 0) {
            this.fileDeleteList.forEach((x) => {
              if (x && x.id) {
                formDatas.append("fileDeleteList", x.id);
              }
            });
          }

          if (this.fromData.sendType === "SCHEDULED" && this.fromData.scheduledTime) {
            formDatas.append("scheduledTime", moment(this.fromData.scheduledTime).format('YYYY-MM-DDTHH:mm:ssZ'));
          }
          NotifyTeacherService.updateNotifyTeacher(formDatas)
            .then((response) => {
              this.$message({
                message: response.data.message,
                type: "success",
              });
              setTimeout(() => {
                this.closeDialogByButton(form);
              }, 500);
              this.messageWarningFile = false;
              this.messageWarningImg = false;
              this.handleSaveImagePost();

            })
            .catch((err) => {
              this.$message({
                message: err.response?.data?.message || "Có lỗi xảy ra",
                type: "error",
              });
              this.messageWarningFile = false;
              this.messageWarningImg = false;
            })
            .finally(() => {
              setTimeout(() => {
                this.loadingButton = false;
              }, 500);
              this.messageWarningFile = false;
              this.messageWarningImg = false;
            });
        }
      });
    },

    handleSaveImagePost() {
      this.$refs.textEditor.handleSetActiveImagePost()
    },
    getDataInitial(id) {
      NotifyTeacherService.findByNotifyTeacher(id)
        .then((resp) => {
          const data = resp.data.data;
          this.fromData = {
            id: data.id,
            title: data.title,
            content: data.content,
            link: data.link,
            notifyTeacherAttachFileList: data.notifyTeacherAttachFileList || [],
            sendType: data.sendType,
            scheduledTime: data.scheduledTime
          };
          this.isSent = this.fromData.sendType === notifySendType.SUCCESS || this.fromData.sendType === notifySendType.FAIL;
          this.scopeForm = "class";
          var uniqueClasses = [];
          if (data.kidResponeList.length > 0) {
            var classes = [];
            data.kidResponeList.forEach(e => classes.push(e.idClass));
            uniqueClasses = [...new Set(classes)];
          }

          this.applyForm = {
            classes: uniqueClasses,
            kids: data.kidResponeList || [],
          };
          this.isShowButtonScope = {
            class: true,
          };
          this.imageFileList = [];
          this.excelFileList = [];
          const files = this.fromData.notifyTeacherAttachFileList || [];
          files.forEach(file => {
            let extension = file.name ? file.name.split('.').pop().toLowerCase() : '';
            const fileObj = {
              id: file.id,
              name: file.name || file.url || 'Tệp đính kèm',
              url: file.url || file.attachUrl || file.path
            };
            if (['jpg', 'jpeg', 'png', 'webp'].includes(extension)) {
              this.imageFileList.push(fileObj);
            } else {
              this.excelFileList.push(fileObj);
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    handleChangeImg(file, fileList) {
      let totalFiles = fileList.length + this.excelFileList.length;
      if (totalFiles <= 3) {
        if (file.raw.type.startsWith("image/")) {
          this.imageFileList = fileList;
        }
      } else {
        if (!this.messageWarningImg) {
          this.$message.warning("Tải lên tối đa 3 file");
          this.messageWarningImg = true;
        }
        fileList.forEach(x => {
          if (x.id === undefined) {
            this.handleRemoveImg(x);
          }
        })
      }
    },
    handleChangeFile(file, fileList) {
      let totalFiles = this.imageFileList.length + fileList.length;
      if (totalFiles <= 3) {
        if (!file.raw.type.startsWith("image/")) {
          this.excelFileList = fileList;
        }
      } else {
        if (!this.messageWarningFile) {
          this.$message.warning("Tải lên tối đa 3 file");
          this.messageWarningFile = true;
        }
        fileList.forEach(x => {
          if (x.id === undefined) {
            this.handleRemoveExcel(x);
          }
        })
      }
    },
    resetWaningFile() {
      this.messageWarningFile = false;
    },
    resetWaningImg() {
      this.messageWarningImg = false;
    },
    handleRemoveImg(file, fileList) {
      if (Array.isArray(fileList)) {
        this.imageFileList = fileList;
      } else if (file) {
        this.imageFileList = this.imageFileList.filter((item) => item !== file && item.name !== file.name && item.uid !== file.uid && item.id !== file.id);
      } else {
        this.imageFileList = [];
      }
      if (file && file.id) {
        if (!this.fileDeleteList.some(item => item.id === file.id)) {
          this.fileDeleteList.push(file);
        }
      }
    },
    handleRemoveExcel(file, fileList) {
      if (Array.isArray(fileList)) {
        this.excelFileList = fileList;
      } else if (file) {
        this.excelFileList = this.excelFileList.filter((item) => item !== file && item.name !== file.name && item.uid !== file.uid && item.id !== file.id);
      } else {
        this.excelFileList = [];
      }
      if (file && file.id) {
        if (!this.fileDeleteList.some(item => item.id === file.id)) {
          this.fileDeleteList.push(file);
        }
      }
    },
    downloadItem(file) {
      let id = file.id
      let nameFile = file.name
      http
        .get(`/notify-teacher/download2/${id}`)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", nameFile);
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            message: "Tải về thất bại",
            type: "error",
          });
        });
    },
    handleChangeScopeApply(value) {
      this.isShowButtonScope.class = true;
    },
    handleShowApplyKid() {
      this.isDialogApply.kid = true;
      this.$refs.applyKidSurveyForm.initialDataApply(this.applyForm.classes, this.getDataIdKids(this.applyForm.kids));
    },
    getDataIdKids(kids) {
      return kids.map(kid => kid.idKid);
    },
    handleCloseDialogApplyKid() {
      this.isDialogApply.kid = false;
    },
    handleConfirmKidsApply(value) {
      this.applyForm.classes = value.classesApply;
      this.applyForm.kids = value.kidsApply;
      this.handleCloseDialogApplyKid();
    },
    handleSendTypeChange(value) {
      if (value === 'SCHEDULED' && this.fromData.sendType !== 'SCHEDULED') {
        this.fromData.scheduledTime = null;
      }
    },
    resetScheduledTime() {
      this.fromData.scheduledTime = null;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";

/deep/ .el-input__inner {
  border-radius: 8px;
  background: #f8fafc;
  border-color: #e2e8f0;
}

/deep/ .el-input__inner:focus {
  border-color: #2563eb;
  background: #ffffff;
}

/* ─── Content Toolbar & Mode Switcher ───────────────────── */
.content-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  background: #f8fafc;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.mode-switch-group /deep/ .el-radio-button__inner {
  padding: 6px 12px;
  font-weight: 500;
  font-size: 12px;
}

.dialog-switch-group {
  display: flex;
  gap: 6px;
}

/* ─── Mode 2: HTML Preview Styles ───────────────────────── */
.html-preview-container {
  background: #f1f5f9;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  min-height: 380px;
  display: flex;
  justify-content: center;
}

.preview-device-card {
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  &.preview-large-box {
    min-height: 480px;
  }
}

.preview-card-header {
  padding: 12px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .preview-title {
    font-weight: 700;
    font-size: 15px;
    color: #0f172a;
  }
}

.preview-card-body {
  padding: 16px;
  flex: 1;
  overflow-y: auto;
  max-height: 400px;
}

.preview-empty-text {
  text-align: center;
  color: #94a3b8;
  padding: 40px 0;
  font-size: 14px;

  i {
    font-size: 24px;
    display: block;
    margin-bottom: 8px;
  }
}

/* ─── Mode 3: HTML Source Code Styles ──────────────────── */
.html-source-container {
  background: #0f172a;
  border-radius: 8px;
  padding: 10px;
  border: 1px solid #334155;
}

.source-code-header {
  margin-bottom: 8px;
  .source-info {
    color: #38bdf8;
    font-size: 12px;
    font-weight: 600;
  }
}

/deep/ .source-code-textarea .el-textarea__inner {
  font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace !important;
  font-size: 13px !important;
  line-height: 1.5 !important;
  background-color: #1e293b !important;
  color: #f1f5f9 !important;
  border: 1px solid #334155 !important;
  border-radius: 6px !important;
  padding: 10px !important;
}

/* ─── HTML Content Render Styles ───────────────────── */
.html-content-render {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 14.5px;
  line-height: 1.6;
  color: #1e293b;
  word-break: break-word;

  /deep/ h1, /deep/ h2, /deep/ h3, /deep/ h4, /deep/ h5, /deep/ h6 {
    font-weight: 700;
    color: #0f172a;
    margin-top: 1.2em;
    margin-bottom: 0.6em;
    line-height: 1.3;
  }

  /deep/ h1 { font-size: 1.75em; }
  /deep/ h2 { font-size: 1.4em; }
  /deep/ h3 { font-size: 1.2em; }

  /deep/ p {
    margin-top: 0;
    margin-bottom: 0.8em;
  }

  /deep/ a {
    color: #2563eb;
    text-decoration: underline;
    &:hover {
      color: #1d4ed8;
    }
  }

  /deep/ img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin: 8px 0;
    display: inline-block;
  }

  /deep/ blockquote {
    border-left: 4px solid #3b82f6;
    background-color: #eff6ff;
    margin: 1em 0;
    padding: 10px 16px;
    border-radius: 0 8px 8px 0;
    color: #1e40af;
    font-style: italic;
  }

  /deep/ table {
    border-collapse: collapse;
    width: 100%;
    margin: 1em 0;

    td, th {
      border: 1px solid #cbd5e1;
      padding: 8px 12px;
      text-align: left;
    }

    th {
      background-color: #f1f5f9;
      font-weight: 600;
    }
  }

  /deep/ ul, /deep/ ol {
    padding-left: 24px;
    margin-bottom: 1em;
  }

  /deep/ li {
    margin-bottom: 0.4em;
  }

  /deep/ pre, /deep/ code {
    font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
    background-color: #f1f5f9;
    border-radius: 4px;
    padding: 2px 6px;
    font-size: 0.9em;
  }

  /deep/ pre {
    padding: 12px;
    overflow-x: auto;
    code {
      padding: 0;
      background: transparent;
    }
  }
}

/* ─── 2-Column Dialog & Card Box Styles ───────────────────── */
.notify-two-col-form {
  /deep/ .el-form-item__label {
    font-weight: 600;
    color: #334155;
    padding-bottom: 4px;
    font-size: 13px;
  }
}

.notify-card-box {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);

  .card-box-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f1f5f9;

    i {
      font-size: 16px;
      color: #2563eb;
    }
    .card-title {
      font-weight: 600;
      font-size: 13px;
      color: #1e293b;
    }
    .badge-file-count {
      margin-left: auto;
      font-size: 11px;
      font-weight: 600;
      color: #64748b;
      background: #f1f5f9;
      padding: 2px 8px;
      border-radius: 10px;
    }
  }
}

.nfs-scope-list-box {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  padding: 8px 10px;
  transition: all 0.2s ease;
  
  &.is-disabled {
    background-color: #f8fafc;
    border: 1px dashed #cbd5e1;
    opacity: 0.6;
  }
}

.nfs-list-box-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 6px;
  margin-bottom: 6px;
  
  .title-left {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12.5px;
    font-weight: 700;
    color: #1e293b;
  }

  .nfs-title-tag {
    font-size: 12px;
    font-weight: 700;
    color: #2563eb;
  }
}

.nfs-list-box-content {
  max-height: 125px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-right: 2px;
  
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 2px;
  }

  .nfs-no-selection {
    font-size: 12px;
    color: #94a3b8;
    text-align: center;
    padding: 12px 0;
    font-style: italic;
  }
}

.nfs-apply-pill {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  background: #eff6ff;
  color: #2563eb;
  border: 1px solid #dbeafe;
  padding: 5px 8px;
  border-radius: 6px;
  font-size: 11.5px;
  font-weight: 500;
  box-sizing: border-box;
  line-height: 1.3;
  word-break: break-word;

  i {
    font-size: 13px;
    color: #10b981;
    flex-shrink: 0;
  }
}

/* Segmented Radio Buttons */
.send-type-segmented {
  display: flex !important;
  width: 100%;

  /deep/ .el-radio-button {
    flex: 1;
    display: flex;

    .el-radio-button__inner {
      width: 100%;
      border-radius: 6px !important;
      padding: 9px 12px;
      font-weight: 500;
      font-size: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      box-sizing: border-box;
    }
  }

  /deep/ .el-radio-button:first-child .el-radio-button__inner {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  /deep/ .el-radio-button:last-child .el-radio-button__inner {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-left: 0 !important;
  }
}

.upload-drop-section {
  .upload-sublabel {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    margin-bottom: 6px;
    i {
      color: #3b82f6;
    }
  }
}

/* Drag & Drop Upload Zone Styling */
.drag-dropzone-uploader {
  width: 100%;
  /deep/ .el-upload {
    width: 100%;
    border: none !important;
    background: transparent !important;
  }
  /deep/ .el-upload-dragger {
    width: 100%;
    height: 70px;
    border-radius: 8px;
    border: 1.5px dashed #cbd5e1;
    background: #f8fafc;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    transition: all 0.2s ease;

    &:hover {
      border-color: #2563eb;
      background-color: #eff6ff;
    }

    .el-icon-upload {
      font-size: 24px;
      color: #3b82f6;
      margin: 0;
      line-height: 1;
    }
    .el-upload__text {
      font-size: 11px;
      color: #64748b;
      em {
        color: #2563eb;
        font-weight: 600;
        font-style: normal;
      }
    }
  }
  /deep/ .el-upload-list--picture-card {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;

    .el-upload-list__item {
      width: 70px;
      height: 70px;
      margin: 0;
      border-radius: 8px;
    }
  }
}

.drag-dropzone-file-uploader {
  width: 100%;
  /deep/ .el-upload {
    width: 100%;
  }
  /deep/ .el-upload-dragger {
    width: 100%;
    height: 70px;
    border-radius: 8px;
    border: 2px dashed #cbd5e1;
    background: #f8fafc;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    transition: all 0.2s ease;

    &:hover {
      border-color: #2563eb;
      background-color: #eff6ff;
    }

    .el-icon-upload {
      font-size: 22px;
      color: #3b82f6;
      margin: 0;
      line-height: 1;
    }
    .el-upload__text {
      font-size: 11px;
      color: #64748b;
      em {
        color: #2563eb;
        font-weight: 600;
        font-style: normal;
      }
    }
  }
}
</style>
